import {
  Button,
  Checkbox,
  Col,
  Form,
  Input,
  Row,
  Space,
  Typography,
} from 'antd';
interface DeleteUserAccountComponentProps {
  onFinish: (newPassword: string) => void;
  goBack?: () => void;
}
function DeleteUserAccountComponent({
  onFinish,
  goBack,
}: DeleteUserAccountComponentProps) {
  const { Text } = Typography;
  const [form] = Form.useForm();

  return (
    <div>
      <Row justify="center" style={{ marginTop: '70px' }}>
        <Col span={12}>
          <h1>사용자 계정 삭제</h1>
          <h2>정말 계정을 삭제 하시겠습니까?</h2>
        </Col>
      </Row>
      <Row justify="center" style={{ marginBottom: '20px' }}>
        <Col span={12}>
          <Form layout="vertical" form={form} onFinish={onFinish}>
            <Form.Item
              name="value1"
              valuePropName="checked"
              rules={[
                {
                  validator: (_, value) =>
                    value
                      ? Promise.resolve()
                      : Promise.reject(
                          new Error('계정 삭제 시 반드시 체크 되어야 합니다.'),
                        ),
                },
              ]}
            >
              <Checkbox>
                계정 삭제 시 더 이상 하이공사 서비스를 사용할 수 없습니다.
              </Checkbox>
            </Form.Item>
            <Form.Item
              name="value2"
              valuePropName="checked"
              rules={[
                {
                  validator: (_, value) =>
                    value
                      ? Promise.resolve()
                      : Promise.reject(
                          new Error('계정 삭제 시 반드시 체크 되어야 합니다.'),
                        ),
                },
              ]}
            >
              <Checkbox>
                사용자가 등록한 게시물과 파일은 삭제되지 않습니다.
              </Checkbox>
            </Form.Item>
            <Form.Item
              name="value3"
              valuePropName="checked"
              rules={[
                {
                  validator: (_, value) =>
                    value
                      ? Promise.resolve()
                      : Promise.reject(
                          new Error('계정 삭제 시 반드시 체크 되어야 합니다.'),
                        ),
                },
              ]}
            >
              <Checkbox>
                <Text type="warning">
                  계정 삭제 시 해당 계정은 즉시 삭제 처리되며 복원이 불가함을
                  확인했습니다.
                </Text>
              </Checkbox>
            </Form.Item>
            <Form.Item
              name="userName"
              label="사용자 이름"
              validateFirst={true}
              rules={[
                {
                  required: true,
                  message: '현재 비밀번호를 입력하세요.',
                },
              ]}
            >
              <Input placeholder="사용자 이름을 입력하세요." />
            </Form.Item>
            <Form.Item>
              <Row justify="center">
                <Space>
                  <Button onClick={goBack}>뒤로</Button>
                  <Button
                    htmlType="submit"
                    type="primary"
                    disabled={
                      form
                        .getFieldsError()
                        .filter(({ errors }) => errors.length).length > 0
                    }
                  >
                    확인
                  </Button>
                </Space>
              </Row>
            </Form.Item>
          </Form>
        </Col>
      </Row>
    </div>
  );
}
export default DeleteUserAccountComponent;
